import axios from 'src/utils/axios';
import { fetchAuthSession } from 'aws-amplify/auth';
import { apiGateway } from 'src/config';

import type { AxiosResponse } from 'axios';
import type { Item } from 'src/@types/common';

export const itemAPI = {
  async getItemList(values: FormData) {
    return axios.post(apiGateway + '/item/get', values);
  },
  async getItem(itemCode: string): Promise<Item> {
    const token = (await fetchAuthSession()).tokens?.idToken?.toString();
    const response: AxiosResponse = await axios.get<Item>(apiGateway + '/item/' + itemCode, {
      headers: {
        Authorization: 'Bearer ' + token,
      },
      timeout: 60000,
    });

    return response.data;
  },
};
